function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_421_3741)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6 6.8a1 1 0 10-1.2-1.6l-28 21a1 1 0 101.2 1.6l28-21zM17 5a8.972 8.972 0 016.416 2.688l-1.619 1.214a7.002 7.002 0 00-11.735 4.159.996.996 0 01-.318.607A.997.997 0 019 14a6 6 0 00-5.424 8.568L1.95 23.787a8.001 8.001 0 016.264-11.749C9.11 8.011 12.703 5 17 5zM24.312 12.016l1.96-1.47a4.999 4.999 0 012.248 6.595A6 6 0 0125 28H9c-1.59 0-3.07-.465-4.316-1.264l1.75-1.312A5.977 5.977 0 009 26h16a4 4 0 001.785-7.58.999.999 0 01-.432-1.559 3 3 0 00-2.04-4.845z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_421_3741"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));